import { generateCode } from "./input-order-functions";
import React from "react";

const generalInfoFields = (props) => {

    return [
        [
            {
                "key": "order_code",
                type: 'render',
                colSize: 12,
                "render": (_, Form, node) => {
                    return (
                        <div style={{ fontSize: 'larger' }}>
                            <b>
                                Número: {Form.state.formRef.order_code || ''}
                            </b>
                        </div>
                    )
                },
                'element-attr': { required: false, },
                beforeSave: async (_, parseObject) => {

                    if (!parseObject.get('order_code')) {
                        const code = await generateCode();
                        await parseObject.set('order_code', code);
                    }

                    return true;
                }
            },
        ],
        [
            {
                "title": "Fornecedor",
                "key": "provider",
                "type": "pointer",
                colSize: 6,
                "options": props.providers.map(provider => {
                    return {
                        label: `${provider.get('code')} - ${provider.get('name')}`,
                        value: provider.id,
                    }
                }),
                "relation-select": {
                    "class": "InputProvider",
                    "label": (obj) => `${obj.code} - ${obj.name}`,
                    "value": "objectId",
                    "key": "objectId",
                },
                "element-attr": {
                    "required": true, 'mode': 'default',
                    afterChange: async (_, node, value) => {
                        const inputs = await props.getInputsFromProvider(value)
                        _.props.module.form.formTabs[1].fields[0][0].fields[0][0].options = inputs
                        _.forceUpdate()
                    }
                },
            },
            {
                "title": "Prazo de pagamento",
                "key": "payment_conditions",
                "type": "select",
                colSize: 4,
                options: [],
                optionConfig: { name: 'pedido_compra_prazo_pgto' },
                "element-attr": { required: false, 'mode': 'default' }
            },
            {
                "title": "Prazo de entrega",
                "key": "delivery_conditions",
                "type": "date-picker",
                colSize: 4,
                "element-attr": { required: false }
            },
            {
                "title": "Observação",
                "key": "obs",
                "type": "text",
                colSize: 10,
                "element-attr": { required: false }
            },
        ],
        [
            {
                "title": "Responsável pelo frete",
                "key": "delivery_responsible",
                colSize: 6,
                "type": "select",
                "options": [
                    { label: 'Selecione...', value: null },
                    { label: 'Comprador - Multidoor', value: 'Comprador - Multidoor' },
                    { label: 'Fornecedor - FOB SP incluso', value: 'Fornecedor - FOB SP incluso' },
                    { label: 'Fornecedor - FOB SP destaque', value: 'Fornecedor - FOB SP destaque' },
                    { label: 'Fornecedor - CIF AL incluso', value: 'Fornecedor - CIF AL incluso' },
                    { label: 'Fornecedor - CIF AL destaque', value: 'Fornecedor - CIF AL destaque' }
                ],
                "element-attr": {
                    required: false, 'mode': 'default',
                }
            },
            {
                "title": "Transportadora",
                "key": "delivery",
                "type": "select",
                colSize: 6,
                "options": props.deliveries,
                "element-attr": {
                    "required": false, 'mode': 'default',
                    afterChange: async (_, node, value) => {
                        const delivery = props.deliveries.find(el => el.value === value)

                        if (delivery.data.get('func_logistics_name') && delivery.data.get('func_logistics_phone'))
                            _.state.formRef.delivery_phone = `${delivery.data.get('func_logistics_name')} - ${delivery.data.get('func_logistics_phone')}`;
                        _.forceUpdate();
                    }
                },
            },
            {
                "title": "Tipo de transporte",
                "key": "delivery_type",
                "type": "select",
                colSize: 6,
                "options": [
                    { label: 'Selecione...', value: null },
                    { label: 'Rodoviário', value: 'Rodoviário' },
                    { label: 'Maritimo - porta a porta', value: 'Maritimo - porta a porta' },
                    { label: 'Maritimo - porto Suape-PE', value: 'Maritimo - porto Suape-PE' },
                    { label: 'Aéreo', value: 'Aéreo' },
                    { label: 'Sedex', value: 'Sedex' }
                ],
                "element-attr": { required: false, 'mode': 'default' }
            },
            {
                "title": "Contato transportadora",
                "key": "delivery_phone",
                "type": "text",
                colSize: 6,
                "element-attr": { required: false },
            },
        ],
        [
            {
                "title": "Faturamento",
                "key": "revenues",
                "type": "select",
                "options": props.salesChannels,
                "element-attr": { "required": true, 'mode': 'default' },
            },
            {
                "title": "Local de entrega",
                "key": "delivery_place",
                "type": "select",
                "options": props.salesChannels,
                "element-attr": { "required": true, 'mode': 'default' },
            },
        ],
        [
            {
                "title": "Destino do insumo",
                "key": "input_destiny",
                "type": "select",
                colSize: 6,
                "options": [
                    { label: 'Selecione...', value: null },
                    { label: 'Industrialização', value: 'Industrialização' },
                    { label: 'Consumo', value: 'Consumo' },
                    { label: 'Manutenção', value: 'Manutenção' },
                    { label: 'Ativo fixo', value: 'Ativo fixo' },
                    { label: 'Revenda', value: 'Revenda' }
                ],
                "element-attr": { required: false, 'mode': 'default' }
            },
            {
                "title": "Cliente",
                "key": "client",
                "type": "pointer",
                colSize: 12,
                "options": props.clients.map(client => {
                    return {
                        label: `${client.get('cod_cliente')} - ${client.get('name_client')}`,
                        value: client.id
                    }
                }),
                "relation-select": {
                    "class": "Client",
                    "label": (obj) => `${obj.cod_cliente} - ${obj.name_client}`,
                    "value": "objectId",
                    "key": "objectId",
                },
                "element-attr": { "required": false, 'mode': 'default' },
            },
            {
                "title": "Pedido",
                "key": "sales_order_code",
                "type": "text",
                colSize: 6,
                "element-attr": { required: false }
            },
        ],
        [
            {
                "title": "Status",
                "key": "status",
                "type": "select",
                "options": [
                    { label: 'Selecione...', value: null },
                    { label: 'Programado', value: 'Programado' },
                    { label: 'Pagamento efetuado', value: 'Pagamento efetuado' },
                    { label: 'Faturado', value: 'Faturado' },
                    { label: 'Recebido', value: 'Recebido' },
                    { label: 'Cancelado', value: 'Cancelado' }
                ],
                "element-attr": { required: false, 'mode': 'multiple' }
            }
        ],
        [
            {
                "title": "Exibir dados bancários no pdf do pedido?",
                "key": "show_provider_banking_info",
                "type": "switch",
                "element-attr": { required: false }
            }
        ]
    ]
}

export default generalInfoFields